import { useComponentRegistry } from '@bem-react/di';
import React from 'react';

import { cnPrefooter } from 'client/common/components/prefooter';

interface IPrefooterItemProps {
    url: string;
    name: string;
}

function PrefooterItem({ url, name }: IPrefooterItemProps) {
    const { Link } = useComponentRegistry('lego');

    return (
        <div className={cnPrefooter('item')}>
            <Link theme="black" href={url}>{name}</Link>
        </div>
    );
}

export default PrefooterItem;
